import { defineStore } from 'pinia'
import cookie from '@ms/utils/cookie.js'
import { REGION_LIST } from '@ms/setting'
import { REGION } from '@ms/config/app'
import { isApp } from 'wap/hybrid/device'
import { ref } from '@vue/composition-api'

// 多国家登录态缓存 key
const REGION_LOGINED = 'RHTJ5V'
const TOKEN = 'accessToken'
let tokenCountry = ''

const clearToken = () => {
  cookie.set(TOKEN, null)
  cookie.set('refreshToken', null)
  cookie.set('userId', null)
  localStorage.removeItem(REGION_LOGINED)
}

const getTokenCountry = () => {
  const token = cookie.get(TOKEN)
  const matched = token.match(/(\d+):patron:id/)
  const regionStr = matched && matched[1]
  if (regionStr) {
    const regionItem = REGION_LIST.find((x) => x.tokenStart === regionStr)
    if (regionItem) {
      return regionItem.country
    }
  }
  return localStorage.getItem(REGION_LOGINED) || ''
}

/*
  多国家登录态对象，主要记录当前登录国家，匹配判断是否已登录
  1. 识别后台模版登录态变量 authenticated，如果是 'true'，视为已登录
  2. 区分切换国家后 accessToken 登录态
  3. 识别 SPA 页面跳转切换登录态
  4. 需要识别 web, mssdk, localhost 登录态 etc. mcards 静态游戏资源包
 */
const regionAuthed = {
  set(authed) {
    const value = authed ? REGION : ''
    localStorage.setItem(REGION_LOGINED, value)
  },
  check() {
    tokenCountry = getTokenCountry()
    // 通过 cookie TOKEN 判断, 如果 token 有值，先假定已登录，后续通过 http 401 修正
    const hasToken = !!cookie.get(TOKEN) && cookie.get(TOKEN) !== '""'

    // 1. 后端判断。后端通过 ftl 模版插值返回了用户登录态，可通过检测模版变量 window.authenticated 判断，字符串 true - 已登录, false - 未登录，其他情况需要自行判断; authenticated === 'false' 可能是后退返回，所以还是需要前端判断
    const authenticated = window.authenticated
    const authed = authenticated === 'true'

    if (hasToken && authed) {
      this.set(authed)
      return authed
    }

    // 2. 前端判断
    if (!hasToken) return false

    if (isApp()) {
      // app 环境下，不需要判断是否是当前国家
      this.set(true)
      return true
    } else if (tokenCountry === REGION) {
      // 判断是否是当前国家
      return true
    } else {
      return false
    }
  }
}

const loginStatus = ref(regionAuthed.check())

export const updateLoginStatus = (status) => {
  loginStatus.value = status
  status && regionAuthed.set(status)
}

export const useAuthStore = defineStore('auth', () => {
  const update = (status = false) => {
    updateLoginStatus(status)
    if (!status && tokenCountry === REGION) {
      clearToken()
    }
  }

  const autoCheck = () => {
    const status = regionAuthed.check()
    update(status)
  }

  return {
    loginStatus,
    update,
    autoCheck,
    clearToken
  }
})
